import React from 'react';

import { ActivityIndicator } from 'components/activity-indicator/ActivityIndicator';

export const LoadingScreen = () => (
    <div className="mt-12 justify-center flex">
        <ActivityIndicator />
    </div>
);
